import React from 'react';
import { motion } from 'framer-motion';
import { 
  GlobeAltIcon,
  EnvelopeIcon
} from '@heroicons/react/24/outline';

const Team = () => {
  const team = [
    { 
      name: 'Sarah Jenkins', 
      role: 'Senior Stylist', 
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200',
      socials: [
        { icon: '🔗', url: 'https://facebook.com' },
        { icon: '𝕏', url: 'https://twitter.com' }
      ]
    },
    { 
      name: 'Michael Chen', 
      role: 'Color Specialist', 
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200',
      socials: [
        { icon: '🔗', url: 'https://facebook.com' },
        { icon: '𝕏', url: 'https://twitter.com' }
      ]
    },
    { 
      name: 'Emma Watson', 
      role: 'Makeup Artist', 
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=200',
      socials: [
        { icon: '🔗', url: 'https://facebook.com' },
        { icon: '𝕏', url: 'https://twitter.com' }
      ]
    },
    { 
      name: 'David Thompson', 
      role: 'Hair Designer', 
      image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=200',
      socials: [
        { icon: '🔗', url: 'https://facebook.com' },
        { icon: '𝕏', url: 'https://twitter.com' }
      ]
    }
  ];

  return (
    <div className="bg-white py-12 sm:py-20 md:py-24 lg:py-32 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          
          {/* Left: Team Cards Grid */}
          <div className="order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4 sm:gap-6">
              {team.map((member, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: idx * 0.1 }}
                  viewport={{ once: true, margin: '-50px' }}
                  className={`bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 ${
                    idx === 1 || idx === 3 ? 'lg:mt-8' : ''
                  }`}
                >
                  {/* Profile Image */}
                  <div className="relative h-48 sm:h-56 overflow-hidden bg-gray-200">
                    <img 
                      src={member.image} 
                      alt={member.name} 
                      className="w-full h-full object-cover"
                    />
                  </div>

                  {/* Profile Info */}
                  <div className="p-4 sm:p-6 text-center">
                    <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">
                      {member.name}
                    </h3>
                    <p className="text-xs sm:text-sm text-gray-600 mb-4">
                      {member.role}
                    </p>

                    {/* Social Icons */}
                    <div className="flex items-center justify-center gap-3">
                      <a 
                        href={member.socials[0].url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-colors"
                        title="Facebook"
                      >
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                        </svg>
                      </a>
                      <a 
                        href={member.socials[1].url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-colors"
                        title="Twitter"
                      >
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M23.953 4.57a10 10 0 002.856-3.837c-1.052.494-2.19.856-3.387 1.017 1.216-.728 2.15-1.88 2.589-3.25-1.138.675-2.4 1.167-3.749 1.431-.676-1.179-1.772-1.918-2.99-1.918-2.265 0-4.102 1.837-4.102 4.102 0 .322.037.637.11.94-3.406-.172-6.434-1.802-8.457-4.287-.353.61-.556 1.312-.556 2.065 0 1.424.726 2.68 1.825 3.415-.675-.021-1.31-.207-1.863-.515v.052c0 1.988 1.414 3.647 3.293 4.023-.344.095-.707.145-1.08.145-.264 0-.522-.026-.77-.074.522 1.631 2.038 2.816 3.833 2.85-1.404 1.1-3.174 1.756-5.096 1.756-.331 0-.658-.02-.98-.058 1.823 1.17 3.989 1.85 6.31 1.85 7.569 0 11.681-6.268 11.681-11.681 0-.178-.004-.355-.012-.53.8-.578 1.494-1.301 2.042-2.125z"/>
                        </svg>
                      </a>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Right: Heading and Description */}
          <div className="order-1 lg:order-2 flex flex-col justify-start">
            <div className="mb-6">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Our Team
              </h2>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-4">
                Meet our talented team of beauty and wellness professionals dedicated to making you feel your absolute best.
              </p>
              <p className="text-sm sm:text-base text-gray-500 leading-relaxed mb-6">
                With years of combined experience in hair styling, makeup artistry, and wellness services, each member of our team brings expertise, creativity, and passion to every service.
              </p>
            </div>

            {/* Stats or CTA */}
            <div className="grid grid-cols-2 gap-6 pt-6 border-t border-gray-200">
              <div>
                <div className="text-3xl font-bold text-[#F05A35] mb-2">50+</div>
                <p className="text-sm text-gray-600">Trained Professionals</p>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#F05A35] mb-2">10+</div>
                <p className="text-sm text-gray-600">Years Experience</p>
              </div>
            </div>

            {/* CTA Button */}
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="mt-8 inline-flex items-center justify-center gap-2 bg-[#F05A35] text-white px-5 sm:px-6 py-2 sm:py-3 rounded-full font-semibold text-sm sm:text-base hover:bg-[#d94a28] transition-all w-fit mx-auto lg:mx-0"
            >
              Meet The Team
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </motion.button>
          </div>

        </div>

      </div>
    </div>
  );
};

export default Team;
